import { supabase } from '../supabase/client';

interface OperationLog {
  id: string;
  adminId: string;
  adminName: string;
  adminRole: string;
  action: string;
  targetName: string;
  targetPhone: string;
  timestamp: string;
}

export async function addLog(
  adminId: string,
  adminName: string,
  adminRole: string,
  action: string,
  targetName: string,
  targetPhone: string
): Promise<boolean> {
  try {
    const { error } = await supabase.from('admin_operation_logs').insert({
      admin_id: adminId,
      admin_name: adminName,
      admin_role: adminRole,
      operation_type: action,
      target_user_name: targetName,
      target_user_id: targetPhone,
      details: { targetPhone }
    });

    if (error) {
      
      return false;
    }
    return true;
  } catch (e) {
    
    return false;
  }
}

export async function getLogs(): Promise<OperationLog[]> {
  try {
    const thirtyDaysAgo = new Date();
    thirtyDaysAgo.setDate(thirtyDaysAgo.getDate() - 30);

    const { data, error } = await supabase
      .from('admin_operation_logs')
      .select('*')
      .gte('created_at', thirtyDaysAgo.toISOString())
      .order('created_at', { ascending: false });

    if (error) {
      
      return [];
    }

    return (data || []).map(log => ({
      id: log.id,
      adminId: log.admin_id,
      adminName: log.admin_name,
      adminRole: log.admin_role as 'master' | 'sub',
      action: log.operation_type,
      targetName: log.target_user_name || '',
      targetPhone: (log.details as any)?.targetPhone || '',
      timestamp: log.created_at
    }));
  } catch (e) {
    
    return [];
  }
}
